module.exports = new __parcel__URL__("arrow-down-right.fdb894c4.svg").toString();